export default {
  // Common
  common: {
    welcome: 'Welcome',
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    search: 'Search...',
    filter: 'Filter',
    export: 'Export',
    refresh: 'Refresh',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    close: 'Close',
    actions: 'Actions',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    enabled: 'Enabled',
    disabled: 'Disabled',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
    apply: 'Apply',
    download: 'Download',
    upload: 'Upload',
    view: 'View',
    details: 'Details',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    country: 'Country',
    city: 'City',
    state: 'State',
    zipCode: 'Zip Code',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    description: 'Description',
    type: 'Type',
    amount: 'Amount',
    date: 'Date',
    time: 'Time',
    from: 'From',
    to: 'To',
    all: 'All',
    none: 'None',
    select: 'Select',
    selected: 'Selected',
    total: 'Total',
    subtotal: 'Subtotal',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    completed: 'Completed',
    failed: 'Failed',
    processing: 'Processing',
    cancelled: 'Cancelled',
    required: 'Required',
    optional: 'Optional',
    today: 'Today',
    yesterday: 'Yesterday',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    lastMonth: 'Last Month',
    custom: 'Custom',
    range: 'Range',
    noData: 'No data available',
    noResults: 'No results found',
    showMore: 'Show More',
    showLess: 'Show Less',
    expand: 'Expand',
    collapse: 'Collapse',
    clearAll: 'Clear All',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    copyToClipboard: 'Copy to Clipboard',
    copied: 'Copied!',
    notAvailable: 'N/A',
    upgrade: 'Upgrade',
  },

  // Auth
  auth: {
    login: 'Login',
    logout: 'Logout',
    email: 'Email',
    password: 'Password',
    rememberMe: 'Remember Me',
    forgotPassword: 'Forgot Password?',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    loginSuccess: 'Logged in successfully',
    loginError: 'Invalid email or password',
    sessionExpired: 'Session expired. Please login again.',
    adminPanel: 'Admin Panel',
    needHelp: 'Need help?',
    poweredBy: 'Powered by',
    adminPanel: 'Admin Panel',
    needHelp: 'Need help?',
    poweredBy: 'Powered by',
  },

  // Navigation
  nav: {
    dashboard: 'Dashboard',
    instruments: 'Instruments',
    clients: 'Clients',
    accounts: 'Accounts',
    trading: 'Trading',
    reports: 'Reports',
    auditLog: 'Audit Log',
    withdrawals: 'Withdrawals',
    deposits: 'Deposits',
    settings: 'Settings',
    plugins: 'Plugins',
    accountGroups: 'Account Groups',
    kyc: 'KYC',
    apiDocs: 'API Docs',
    notifications: 'Notifications',
    upgrade: 'Upgrade',
    groupPricing: 'Group Pricing',
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    overview: 'Overview',
    stats: 'Statistics',
    totalClients: 'Total Clients',
    totalAccounts: 'Total Accounts',
    openPositions: 'Open Positions',
    todayPnL: "Today's P&L",
    liveAccounts: 'Live Accounts',
    demoAccounts: 'Demo Accounts',
    activeClients: 'Active Clients',
    activeTraders: 'Active Traders',
    newClients: 'New Clients',
    volumeChart: 'Trading Volume (7 Days)',
    pnlTrend: 'P&L Trend (30 Days)',
    recentActivity: 'Recent Activity',
    quickActions: 'Quick Actions',
    financialOverview: 'Financial Overview',
    financialOverview30Days: 'Financial Overview (30 Days)',
    riskAlerts: 'Risk Alerts',
    riskDistribution: 'Risk Distribution',
    currentPlan: 'Current Plan',
    planUsage: 'Plan Usage',
    allowedMarkets: 'Allowed Markets',
    accountOverview: 'Account Overview',
    activeUsers: 'Active Users',
    activeThisMonth: 'Active This Month',
    plan: 'plan',
    feedLatency: 'Feed Latency',
    expires: 'Expires',
    cashFlowComparison: 'Cash Flow Comparison',
    totalTransactions: 'total transactions',
    totalDeposits: 'total deposits',
    totalWithdrawals: 'total withdrawals',
  },

  // Instruments
  instruments: {
    title: 'Instrument Management',
    library: 'Instrument Library',
    enabled: 'Enabled Instruments',
    feed: 'Feed Instruments',
    symbol: 'Symbol',
    category: 'Category',
    priceScale: 'Price Scale',
    leverage: 'Leverage',
    spread: 'Spread',
    commission: 'Commission',
    enable: 'Enable',
    disable: 'Disable',
    bulkEnable: 'Bulk Enable',
    settings: 'Settings',
    tradeMode: 'Trade Mode',
    executionType: 'Execution Type',

    // Categories
    forex: 'Forex',
    crypto: 'Crypto',
    stocks: 'Stocks',
    indices: 'Indices',
    commodities: 'Commodities',

    // Settings tabs
    general: 'General',
    leverageLots: 'Leverage & Lots',
    spreads: 'Spreads',
    commissions: 'Commissions',
    riskManagement: 'Risk Management',
    advanced: 'Advanced',

    // Settings fields
    maxLeverage: 'Max Leverage',
    minLotSize: 'Min Lot Size',
    maxLotSize: 'Max Lot Size',
    lotStep: 'Lot Step',
    spreadType: 'Spread Type',
    spreadMarkup: 'Spread Markup',
    fixedSpread: 'Fixed Spread',
    commissionPerLot: 'Commission Per Lot',
    commissionType: 'Commission Type',
    stopLevel: 'Stop Level',
    freezeLevel: 'Freeze Level',
    maxPositions: 'Max Positions',

    // Messages
    enableSuccess: 'Instrument enabled successfully',
    disableSuccess: 'Instrument disabled successfully',
    updateSuccess: 'Settings updated successfully',
    bulkEnableSuccess: 'Instruments enabled successfully',
  },

  // Clients
  clients: {
    title: 'Clients',
    clientsList: 'Clients List',
    clientDetails: 'Client Details',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    country: 'Country',
    kycStatus: 'KYC Status',
    accountCount: 'Accounts',
    totalBalance: 'Total Balance',
    lastLogin: 'Last Login',
    createdAt: 'Created At',
    verified: 'Verified',
    pending: 'Pending',
    rejected: 'Rejected',
    searchPlaceholder: 'Search clients...',
    nameOrEmail: 'Name or email…',
    editClient: 'Edit client',
    configureOverride: 'Configure user override',
    noClientsFound: 'No clients found',
  },

  // Accounts
  accounts: {
    title: 'Accounts',
    accountsList: 'Accounts List',
    accountDetails: 'Account Details',
    accountNumber: 'Account Number',
    accountType: 'Account Type',
    accountGroup: 'Account Group',
    accountSettings: 'Account Settings',
    accountState: 'Account State',
    accountActive: 'Account Active',
    balance: 'Balance',
    equity: 'Equity',
    margin: 'Margin',
    freeMargin: 'Free Margin',
    marginLevel: 'Margin Level',
    leverage: 'Leverage',
    credit: 'Credit',
    debit: 'Debit',
    adjustBalance: 'Adjust Balance',
    changeLeverage: 'Change Leverage',
    live: 'Live',
    demo: 'Demo',
    searchPlaceholder: 'Search by account number or email...',
    accountNumberOrEmail: 'Account number or email…',
    balanceChange: 'Balance Change',
    reasonForAdjustment: 'Reason for adjustment...',
    accountUpdatedSuccess: 'Account updated successfully',
    noAccountsFound: 'No accounts found',
  },

  // Trading
  trading: {
    title: 'Trading',
    positions: 'Positions',
    orders: 'Orders',
    history: 'History',
    symbol: 'Symbol',
    side: 'Side',
    volume: 'Volume',
    openPrice: 'Open Price',
    currentPrice: 'Current Price',
    pnl: 'P&L',
    buy: 'Buy',
    sell: 'Sell',
    open: 'Open',
    pending: 'Pending',
    closed: 'Closed',
    closedAt: 'Closed At',
    openedAt: 'Opened At',
    price: 'Price',
    totalTrades: 'Total Trades',
    winningTrades: 'Winning Trades',
    losingTrades: 'Losing Trades',
    totalPnL: 'Total P&L',
    account: 'Account',
    status: 'Status',
    swap: 'Swap',
    commission: 'Commission',
    ticket: 'Ticket',
    noPositions: 'No open positions found',
    noOrders: 'No pending orders found',
    noHistory: 'No trade history found',
    bid: 'Bid',
    ask: 'Ask',

    tradingManagement: 'Trading Management',
    liveMonitoring: 'Live Monitoring',
    disconnected: 'Disconnected',
    activeTraders: 'Active Traders',
    openPositions: 'Open Positions',
    pendingOrders: 'Pending Orders',
    totalPnL: 'Total P&L',
    floatPnL: 'Float P&L',
    accountState: 'Account State',
    marginCall: 'MARGIN CALL',
    stopOutRisk: 'STOP-OUT RISK',
    live: 'LIVE',
    offline: 'OFFLINE',
    snapshot: 'SNAPSHOT',
    marginLvl: 'Margin Lvl',
    openTrades: 'Open Trades',
    freeMargin: 'Free Margin',
    marginUsed: 'Margin Used',
    balance: 'Balance',
    equity: 'Equity',
    credit: 'Credit',
    slTp: 'SL / TP',
    fees: 'Fees',
    netPnL: 'Net P&L',
    grossPnL: 'Gross P&L',
    reason: 'Reason',
    openedClosed: 'Opened / Closed',
    closePrice: 'Close Price',
    reserved: 'Reserved',
    reservedMargin: 'Reserved Margin',
    created: 'Created',
    triggerPrice: 'Trigger Price',
    duration: 'Duration',
    closedTrades: 'Closed Trades',
    activeTrades: 'Active',
    stopLoss: 'Stop Loss',
    takeProfit: 'Take Profit',
    closePosition: 'Close Position',
    cancelOrder: 'Cancel Order',
    modifyPosition: 'Modify Position',
    thisActionCannotBeUndone: 'This action cannot be undone',
    enterStopLoss: 'Enter stop loss price',
    enterTakeProfit: 'Enter take profit price',
    filterTrading: 'Filter Trading',
    traderSymbolAccount: 'Trader, symbol, account…',
    noFound: 'No {tab} found',
    showingOf: 'Showing {from}–{to} of {total} traders',
    traderCount: '{count} trader(s) · {total} {tab}',
    positionClosedSuccess: 'Position closed successfully',
    orderCancelledSuccess: 'Order cancelled successfully',
    positionModifiedSuccess: 'Position modified successfully',
    failedToClosePosition: 'Failed to close position',
    failedToCancelOrder: 'Failed to cancel order',
    failedToModifyPosition: 'Failed to modify position',
    invalidPosition: 'Invalid position: missing ID',
  },

  // Reports
  reports: {
    title: 'Reports',
    exposure: 'Exposure Report',
    profitability: 'Client Profitability',
    daily: 'Daily Report',
    dateRange: 'Date Range',
    totalExposure: 'Total Exposure',
    netVolume: 'Net Volume',
    topWinners: 'Top Winners',
    topLosers: 'Top Losers',
    buyVolume: 'Buy Volume',
    sellVolume: 'Sell Volume',
    positionCount: 'Position Count',
    winRate: 'Win Rate',
    rank: 'Rank',
    client: 'Client',
    noData: 'No data available',
    totalVolume: 'Total Volume',
    commission: 'Commission',
    activeAccounts: 'Active Accounts',
    export: 'Export',
    download: 'Download',
    positions: 'Positions',
    trades: 'Trades',
    winning: 'Winning',
    losing: 'Losing',
  },

  // Settings
  settings: {
    title: 'Settings',
    brokerInfo: 'Broker Information',
    brokerSettings: 'Broker Settings',
    brokerName: 'Broker Name',
    brokerNameRequired: 'Broker Name *',
    brokerLogo: 'Broker Logo',
    brokerStatus: 'Broker Status',
    domain: 'Domain',
    primaryColor: 'Primary Color',
    secondaryColor: 'Secondary Color',
    logo: 'Logo',
    supportEmail: 'Support Email',
    supportPhone: 'Support Phone',
    generalInfo: 'General Information',
    branding: 'Branding',
    accountGroups: 'Account Groups',
    addNewGroup: 'Add New Group',
    createFirstGroup: 'Create Your First Group',
    noGroupsFound: 'No account groups found',
    default: 'Default',
    maxLeverage: 'Max Leverage',
    marginCall: 'Margin Call',
    stopOut: 'Stop Out',
    commission: 'Commission',
    maxLotSize: 'Max Lot Size',
    execution: 'Execution',
    hedgingAllowed: 'Hedging Allowed',
    scalpingAllowed: 'Scalping Allowed',
    eaTrading: 'EA Trading',
    nbpEnabled: 'NBP Enabled',
    saving: 'Saving...',
    groupName: 'Group Name',
    description: 'Description',
    editGroup: 'Edit Group',
    deleteGroup: 'Delete Group',
    cannotDeleteDefault: 'Cannot delete default group',
    confirmDelete: 'Are you sure you want to delete "{name}"? This action cannot be undone.',
    groupCreatedSuccess: 'Group created successfully',
    groupUpdatedSuccess: 'Group updated successfully',
    groupDeletedSuccess: 'Group deleted successfully',
    failedToSave: 'Failed to save group',
    failedToDelete: 'Failed to delete group',
    failedToLoad: 'Failed to load account groups',
    saving: 'Saving...',

    // NEW - Missing translations for Settings page
    configureYourBroker: 'Configure your broker information and preferences',
    loadingSettings: 'Loading settings...',
    legalName: 'Legal Name',
    licenseNumber: 'License Number',
    environment: 'Environment',
    contactInformation: 'Contact Information',
    readOnly: 'Read only',
    readOnlyContactSupport: 'Read only — contact support to change',
    supportedLanguages: 'Supported Languages',
    selectLanguagesDescription: 'Select which languages are available on the client portal. At least one language must be selected.',
    systemLimits: 'System Limits',
    maxAccounts: 'Max Accounts',
    maxConcurrentTrades: 'Max Concurrent Trades',
    maintenanceMode: 'Maintenance Mode',
    enableMaintenanceMode: 'Enable Maintenance Mode',
    maintenanceModeDescription: 'When enabled, clients will see the maintenance message instead of the platform',
    maintenanceMessage: 'Maintenance Message',
    maintenanceMessagePlaceholder: 'We are currently performing scheduled maintenance. Please check back soon.',
    saveChanges: 'Save Changes',
    howToConnectDomain: 'How to connect your domain',
    unlockToEdit: 'Unlock to edit domain',
    lockDomain: 'Lock domain',
    changingDomainWarning: 'Changing your domain can break client access. Are you sure you want to unlock it?',
    changingDomainWarningLong: 'Changing your domain can break client access and DNS settings temporary. Are you sure you want to unlock it?',
    domainBreakWarning: '⚠️ Changing domain may break existing client access temporary',
    domainBreakWarningLong: '⚠️ Changing domain may break existing client access and DNS routing temporary',
  },

  // Account Groups
  accountGroups: {
    title: 'Account Groups',
    activeGroups: 'active',
    defaultGroups: 'default',
    addNewGroup: 'Add New Group',
    createFirstGroup: 'Create Your First Group',
    noGroupsFound: 'No account groups found',
    groupDetails: 'Group Details',
    pricingOverrides: 'Pricing Overrides',
    riskSettings: 'Risk Settings',
    tradingSettings: 'Trading Settings',
  },

  // Group Pricing
  groupPricing: {
    title: 'Group Pricing Overrides',
    infoBanner: 'Account Group Pricing Overrides',
    infoDescription: 'Configure custom pricing for entire account groups. Leave fields empty (NULL) to use broker-level defaults.',
    editPricingOverrides: 'Edit Pricing Overrides',
    spreadMarkup: 'Spread Markup',
    spreadMarkupPips: 'Spread Markup (pips)',
    commission: 'Commission',
    commissionPerLot: 'Commission Per Lot (USD)',
    maxLeverageOverride: 'Max Leverage Override',
    brokerDefault: 'Broker Default',
    useBrokerDefault: 'Use Broker Default',
    clearUseBrokerDefault: 'Clear (use broker default)',
    saveOverrides: 'Save Overrides',
    overridesUpdatedSuccess: 'Group pricing overrides updated successfully',
    failedToUpdate: 'Failed to update overrides',
    leaveEmptyInfo: 'Leave fields empty to use broker-level defaults. Only set values that should override for this group.',
    pips: 'pips',
    perLot: '/lot',
  },

  // KYC
  kyc: {
    title: 'KYC Dashboard',
    allKyc: 'All KYC',
    allStatus: 'All Status',
    allKycStatus: 'All KYC Status',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    verified: 'Verified',
    actionNeeded: 'Action needed',
    awaitingAction: 'Awaiting action',
    allCaughtUp: 'All caught up!',
    noApplications: 'No pending KYC applications at the moment.',
    searchPlaceholder: 'Search by name, email, or ID...',
    nameEmailOrId: 'ID, name or email…',
    confirmApproval: 'Confirm KYC approval',
    confirmRejection: 'Confirm rejection — enter a reason (required).',
    rejectionReason: 'Explain why this application is being rejected (required)',
    approveSuccess: 'KYC approved successfully',
    rejectSuccess: 'KYC rejected successfully',
    failedToApprove: 'Failed to approve KYC',
    failedToReject: 'Failed to reject KYC',
    basicVerified: 'Basic Verified',
    fullVerified: 'Full Verified',
    allApplications: 'All Applications',


    kycVerification: 'KYC Verification',
    reviewManageDesc: 'Review and manage customer verification applications',
    pluginSettings: 'Plugin Settings',
    reviewKycApplication: 'Review KYC Application',
    verificationLevel: 'Verification Level',
    personalInformation: 'Personal Information',
    fullName: 'Full Name',
    dateOfBirth: 'Date of Birth',
    nationality: 'Nationality',
    addressLabel: 'Address',
    sourceOfFunds: 'Source of Funds',
    noPersonalData: 'No personal data submitted yet',
    uploadedDocuments: 'Uploaded Documents',
    noDocumentsUploaded: 'No documents uploaded yet',
    yourDecision: 'Your Decision',
    approve: 'Approve',
    reject: 'Reject',
    rejectionReasonLabel: 'Rejection Reason',
    submitting: 'Submitting…',
    submitReview: 'Submit Review',
    previewNotAvailable: 'Preview not available',
    downloadFile: 'Download File',
    uploaded: 'Uploaded',
    pendingReview: 'Pending Review',
    allApplications: 'All Applications',
    allLevels: 'All Levels',
    allStatuses: 'All Statuses',
    allActions: 'All Actions',
    userCol: 'User',
    currentLevel: 'Current Level',
    docsCol: 'Docs',
    lastUpdated: 'Last Updated',
    levelCol: 'Level',
    actionCol: 'Action',
    performedBy: 'Performed By',
    detailsCol: 'Details',
    dateTime: 'Date & Time',
    submittedCol: 'Submitted',
    noApplicationsFound: 'No applications found',
    noAuditRecords: 'No audit records found',
    noMatchingApplications: 'No matching applications',
    noPendingApplications: 'No pending applications',
    systemAuto: 'System (Auto)',
    admin: 'Admin',
    traderLabel: 'Trader',
    upgradedTo: 'Upgraded to',
    pendingApplications: 'pending application',
    pendingApplicationsPlural: 'pending applications',
    users: 'user',
    usersPlural: 'users',
    records: 'record',
    recordsPlural: 'records',
    applications: 'application',
    applicationsPlural: 'applications',
    totalUsers: 'Total Users',
    basicVerifiedStat: 'Basic Verified',
    moderateVerified: 'Moderate Verified',
    fullyVerified: 'Fully Verified',
    pendingSuffix: '+{count} pending',
    levelBasic: 'Basic',
    levelModerate: 'Moderate',
    levelVerified: 'Verified',
    notStarted: 'Not Started',
    none: 'None',
    unknown: 'Unknown',
    review: 'Review',
    auditLog: 'Audit Log',

    requiredDocuments: 'Required Documents',
    requiredDocsDesc: 'Select which documents traders must upload for each KYC level. At least one document is required per level.',
    kycDocuments: '{level} KYC Documents',
    selected: '{count} selected',
    approvalMode: 'Approval Mode',
    manualReview: 'Manual Review',
    autoApprove: 'Auto-Approve',
    autoApproveLevels: 'Auto-Approve Levels',
    basicKyc: 'Basic KYC',
    moderateKyc: 'Moderate KYC',
    verifiedKyc: 'Verified KYC',
    enforceOnDeposit: 'Enforce KYC on Deposits',
    enforceOnWithdrawal: 'Enforce KYC on Withdrawals',
    basic: 'Basic',
    moderate: 'Moderate',
    verified: 'Verified',
    howItWorks: 'How it works:',
    howItWorksBullet1: 'Amounts below Basic threshold: No KYC required',
    howItWorksBullet2: 'Amounts above Basic: Basic KYC required',
    howItWorksBullet3: 'Amounts above Moderate: Moderate KYC required',
    howItWorksBullet4: 'Amounts above Verified: Full verification required',
    saveConfiguration: 'Save Configuration',
    savingConfiguration: 'Saving...',
    openKycDashboard: 'Open KYC Dashboard',
    enableToViewStats: 'Enable plugin to view statistics',
    statNone: 'None',

    // Document type labels/descriptions
    docGovIdFrontLabel: 'Government ID (Front)',
    docGovIdFrontDesc: 'Passport, driver license, or national ID - front side',
    docGovIdBackLabel: 'Government ID (Back)',
    docGovIdBackDesc: 'Back side of ID card',
    docSelfieLabel: 'Selfie with ID',
    docSelfieDesc: 'Photo holding ID next to face',
    docProofAddressLabel: 'Proof of Address',
    docProofAddressDesc: 'Utility bill or bank statement (< 3 months old)',
    docBankStatementLabel: 'Bank Statement',
    docBankStatementDesc: 'Recent statement showing name and account',
    docSourceFundsLabel: 'Source of Funds',
    docSourceFundsDesc: 'Document proving source of trading funds',
    docEmploymentLabel: 'Employment Letter',
    docEmploymentDesc: 'Employer confirmation letter',
    docTaxIdLabel: 'Tax ID Document',
    docTaxIdDesc: 'Tax identification certificate',
    docOtherLabel: 'Other Documents',
    docOtherDesc: 'Additional supporting documents',

    auditActions: {
      submitted: 'Submitted',
      approved: 'Approved',
      rejected: 'Rejected',
      document_uploaded: 'Doc Uploaded',
      document_approved: 'Doc Approved',
      document_rejected: 'Doc Rejected',
      level_upgraded: 'Level Upgraded',
      resubmission: 'Resubmission',
    },
  },

  // Deposits
  deposits: {
    title: 'Deposits',
    allDeposits: 'All Deposits',
    allStatuses: 'All Statuses',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    completed: 'Completed',
    searchPlaceholder: 'Search deposits…',
    searchByIdNameEmail: 'Search by ID, trader name or email…',
    idNameOrEmail: 'ID, name or email…',
    depositProof: 'Deposit proof',
    depositProofPdf: 'Deposit proof PDF',
    amount: 'Amount',
    method: 'Method',
    status: 'Status',
    trader: 'Trader',
    date: 'Date',
    actions: 'Actions',
    approve: 'Approve',
    reject: 'Reject',
    confirmApproval: 'Confirm approval — this will credit the trader\'s balance.',
    confirmRejection: 'Confirm rejection — enter a reason (optional).',
    rejectionReason: 'Reason for rejection (optional)…',
    approveSuccess: 'Deposit approved successfully',
    rejectSuccess: 'Deposit rejected successfully',
    failedToApprove: 'Failed to approve deposit',
    failedToReject: 'Failed to reject deposit',
    noDepositsFound: 'No deposits found',
    proofThumbnail: 'Proof thumbnail',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    openInNewTab: 'Open in new tab',
    bank: 'Bank',
    crypto: 'Crypto',
    card: 'Card',
    bankPerCountry: 'Bank (Per Country)',
    bankPerUser: 'Bank (Per User)',
    bankTransfer: 'Bank Transfer',
    bankTransferPerCountry: 'Bank Transfer (Per Country)',
    bankTransferPerUser: 'Bank Transfer (Per User)',
    averageDeposit: 'Average Deposit',
  },

  // Withdrawals
  withdrawals: {
    title: 'Withdrawals',
    allWithdrawals: 'All Withdrawals',
    allStatuses: 'All Statuses',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    completed: 'Completed',
    searchPlaceholder: 'Search withdrawals…',
    searchByIdNameEmail: 'Search by ID, trader name or email…',
    idNameOrEmail: 'ID, name or email…',
    amount: 'Amount',
    method: 'Method',
    status: 'Status',
    trader: 'Trader',
    date: 'Date',
    actions: 'Actions',
    approve: 'Approve',
    reject: 'Reject',
    confirmApproval: 'Confirm approval — funds will be released to the trader\'s payout details.',
    confirmWithdrawalApproval: 'Confirm withdrawal approval — funds will be released to the trader\'s payout details.',
    confirmRejection: 'Confirm rejection — enter a reason (optional).',
    rejectionReason: 'Reason for rejection (optional)…',
    approveSuccess: 'Withdrawal approved successfully',
    rejectSuccess: 'Withdrawal rejected successfully',
    failedToApprove: 'Failed to approve withdrawal',
    failedToReject: 'Failed to reject withdrawal',
    noWithdrawalsFound: 'No withdrawals found',
    averageWithdrawal: 'Average Withdrawal',
  },

  // Audit Log
  auditLog: {
    title: 'Audit Log',
    allActions: 'All Actions',
    allEvents: 'All Events',
    allLevels: 'All Levels',
    searchPlaceholder: 'Search audit log…',
    emailActionOrId: 'Email, action, or ID…',
    event: 'Event',
    user: 'User',
    action: 'Action',
    timestamp: 'Timestamp',
    details: 'Details',
    level: 'Level',
    info: 'Info',
    warning: 'Warning',
    error: 'Error',
    critical: 'Critical',
    noLogsFound: 'No audit logs found',
    administrativeAction: 'An administrative action was recorded.',

    filterAuditLog: 'Filter Audit Log',
    reset: 'Reset',
    eventType: 'Event Type',
    apply: 'Apply',
    totalEvents: 'Total Events',
    depositEvents: 'Deposit Events',
    withdrawalEvents: 'Withdrawal Events',
    noEventsMatch: 'No events match this filter',
    noEntriesMatch: 'No audit entries match the current filter.',
    showAll: 'Show all',
    events: 'event',
    eventsPlural: 'events',
    totalEventsRecorded: 'Total events recorded',
    performedBy: 'Performed By',
    amount: 'Amount',
    paymentMethod: 'Payment Method',
    balanceChange: 'Balance Change',
    statusChange: 'Status Change',
    rejectionReason: 'Rejection Reason',

    // Action labels
    actionWithdrawalRequested: 'Withdrawal Requested',
    actionDepositSubmitted: 'Deposit Submitted',
    actionProofUploaded: 'Proof Uploaded',
    actionDepositApproved: 'Deposit Approved',
    actionDepositRejected: 'Deposit Rejected',
    actionWithdrawalApproved: 'Withdrawal Approved',
    actionWithdrawalRejected: 'Withdrawal Rejected',
    actionFundsLocked: 'Funds Locked',
    actionFundsReturned: 'Funds Returned',
    fundsLockedSummary: 'Funds locked from trader account pending withdrawal review.',
    fundsReturnedSummary: 'Locked funds were returned to the trader after rejection.',

    // Tab labels
    allEvents: 'All Events',
    depositsTab: 'Deposits',
    withdrawalsTab: 'Withdrawals',
  },

  // Plugins
  plugins: {
    title: 'Plugins',
    backToPlugins: 'Back to Plugins',
    searchPlaceholder: 'Search plugins…',
    countrySelectNoMatch: 'No match',
    configurePlugin: 'Configure Plugin',
    pressEscToClose: 'Press {key} to close',
    loadingUsers: 'Loading…',
    available: 'Available',
    active: 'Active',
    activate: 'Activate',
    deactivate: 'Deactivate',
    configure: 'Configure',
    documentation: 'Documentation',
    settings: 'Settings',
    noPluginsFound: 'No plugins found',
    pluginDetails: 'Plugin Details',
    version: 'Version',
    author: 'Author',
    description: 'Description',
    filterInactive: 'Inactive',

    // Payment Plugins
    paymentGateways: 'Payment Gateways',
    stripeTitle: 'Stripe',
    stripeDescription: 'Accept payments via Stripe',
    paypalTitle: 'PayPal',
    paypalDescription: 'Accept payments via PayPal',

    // Communication
    communicationTools: 'Communication Tools',
    twilioTitle: 'Twilio SMS',
    twilioDescription: 'Send SMS notifications',
    mailgunTitle: 'Mailgun',
    mailgunDescription: 'Email delivery service',

    bankFieldAccountHolder: 'Account holder',
    bankFieldBankName: 'Bank name',
    bankFieldAccountNumber: 'Account number',
    bankFieldRoutingNumber: 'Routing number (optional)',
    bankFieldSetAsDefault: 'Set as default (global fallback)',

    // Copy Trading
    copyTradingTitle: 'Copy Trading',
    copyTradingDescription: 'Enable copy trading features',

    // Trading Tools
    tradingTools: 'Trading Tools',
    mam: 'MAM/PAMM',

    // Configuration fields
    apiKey: 'API Key',
    apiSecret: 'API Secret',
    accountSid: 'Account SID',
    authToken: 'Auth Token',
    authDomain: 'Auth Domain',
    appId: 'App ID',


    loadingPlugins: 'Loading plugins…',
    noPluginsMatch: 'No plugins match your criteria',
    tryDifferentSearch: 'Try a different search or filter',
    tryAdjustingSearch: 'Try adjusting your search or filter',
    activeCount: '{count} active · {owned} owned · {available} in store',
    ofPurchasedActive: 'of {count} purchased active',
    available: 'Available',
    expired: 'Expired',
    expires: 'Expires',
    free: 'Free',
    buyPlugin: 'Buy — ${price}{cycle}',
    openInFullPage: 'Open in full page',
    noConfigPanel: 'No configuration panel available for this plugin.',
    currentStatus: 'Current Status',
    failedToUpdateKyc: 'Failed to update KYC configuration',
    filterAll: 'All',
    filterActive: 'Active',
    filterOwned: 'Owned',
    filterStore: 'Store',

    backToPlugins: 'Back to Plugins',
    pluginNotFound: 'Plugin not found',
    loadingPlugin: 'Loading plugin...',
    failedToLoadPlugin: 'Failed to load plugin',
    noConfigAvailable: 'No configuration panel available for this plugin.',
    activeStatus: 'Active',

    // Shared form actions
    editLabel: 'Edit',
    newLabel: 'New',
    addLabel: 'Add',
    saveLabel: 'Save',
    cancelLabel: 'Cancel',

    // GlobalBankPanel
    globalBankAccount: 'Global Bank Account',
    addBankAccount: 'Add bank account',
    defaultLabel: '(default)',

    // CryptoWalletsPanel
    cryptoWallet: 'Crypto Wallet',
    addCryptoWallet: 'Add crypto wallet',
    coinPlaceholder: 'Coin (e.g. BTC)',
    networkPlaceholder: 'Network (e.g. mainnet)',
    walletAddressPlaceholder: 'Wallet address',
    labelOptionalPlaceholder: 'Label (optional)',

    // PaymentLinksPanel
    paymentLink: 'Payment Link',
    addPaymentLink: 'Add payment link',
    linkNamePlaceholder: 'Name (e.g. Stripe Checkout)',

    // PerUserBankPanel
    perUserBankAccount: 'Per-User Bank Account',
    addUserBankMapping: 'Add user → bank mapping',
    editExistingAccount: 'Edit existing account',
    assignedUsers: 'Assigned users',
    pickTraders: 'Pick trader(s)',
    searchAddTrader: 'Search and add trader…',

    // PerCountryBankPanel
    perCountryBankAccount: 'Per-Country Bank Account',
    addCountryBankMapping: 'Add country → bank mapping',
    mappedCountries: 'Mapped countries',
    pickCountries: 'Pick country(ies)',
    searchAddCountries: 'Search and add countries…',

    // PluginBadge
    badgeActive: 'Active',
    badgeInactive: 'Inactive',
    badgeExpired: 'Expired',

    // PluginPurchaseModal
    purchasePlugin: 'Purchase Plugin',
    paymentMethod: 'Payment Method',
    generatePaymentAddress: 'Generate Payment Address',
    sendExactly: 'Send exactly',
    toAddressBelow: 'to the address below',
    paymentAddress: 'Payment Address',
    waitingForPayment: 'Waiting for payment...',
    paymentDetected: 'Payment Detected! Confirming...',
    confirmationsReceived: '{count} confirmation received',
    confirmationsReceivedPlural: '{count} confirmations received',
    expiresIn: 'Expires in:',
    paymentId: 'Payment ID:',
    paymentConfirmed: 'Payment Confirmed!',
    pluginActivated: '{name} has been activated.',
    networkError: 'Network error. Please try again.',
    failedToCreatePayment: 'Failed to create payment',
    paymentExpired: 'Payment window expired. Please create a new payment.',
  },

  // API Docs
  apiDocs: {
    title: 'API Documentation',
    authentication: 'Authentication',
    baseUrl: 'Base URL:',
    allRequestsRequire: 'All requests require two headers:',
    apiKeyManagement: 'API key management with scope controls',
    billing: 'Billing',
    apiAccess: 'API Access',
    apiAccessAddon: 'API Access add-on active',
    buyAddon: 'Buy Add-on — $199/mo',

    // Endpoints
    getAccounts: 'GET /accounts',
    getAccountDetails: 'GET /accounts/:id',
    updateAccount: 'PATCH /accounts/:id',
    getDeposits: 'GET /deposits',
    approveDeposit: 'POST /deposits/:id/approve',
    rejectDeposit: 'POST /deposits/:id/reject',
    getWithdrawals: 'GET /withdrawals',
    approveWithdrawal: 'POST /withdrawals/:id/approve',
    rejectWithdrawal: 'POST /withdrawals/:id/reject',

    // Descriptions
    approvalsDescription: 'Approve deposits and withdrawals programmatically',
    approveDepositDesc: 'Approve deposit (status must be proof_uploaded). Credits account balance, logs transaction, notifies engine. Body: notes?. Returns balance_before and balance_after.',
    approveWithdrawalDesc: 'Approve a pending withdrawal. Balance was already locked at request time. Body: notes?',

    restApi: 'REST API',
    baseUrlLabel: 'Base URL:',
    authentication: 'Authentication',
    allRequestsRequire: 'All requests require two headers:',
    yourApiKeys: 'Your API Keys',
    noApiKeysYet: 'No API keys yet',
    generateNewKey: 'Generate New Key',
    revokeKey: 'Revoke',
    rateLimit: 'Rate limit',
    maxKeys: 'Max keys',
    reqPerMin: '{limit} req/min',
    exampleRequest: 'Example Request',
    queryParameters: 'Query Parameters',
    endpoints: 'endpoint',
    endpointsPlural: 'endpoints',

    // Access banner
    includedInPlan: 'Included in your Enterprise plan',
    addonActive: 'API Access add-on active',

    // Upsell screen
    restApiAccess: 'REST API Access',
    restApiDesc: 'REST API access is available on the Enterprise plan or as a standalone add-on for any plan. Connect your systems directly to your broker platform.',
    featureReadClients: 'Read clients, accounts and trade history',
    featureApprovePayments: 'Approve deposits and withdrawals programmatically',
    featureApiKeyManagement: 'API key management with scope controls',
    featureRateLimit: 'Up to 60 requests per minute per key',
    featureInteractiveDocs: 'Interactive documentation in your dashboard',
    upgradeToEnterprise: 'Upgrade to Enterprise',
    buyAddonPrice: 'Buy Add-on — $199/mo',

    // Create key modal
    generateApiKey: 'Generate API Key',
    keyName: 'Key Name',
    keyNamePlaceholder: 'e.g. Production Key',
    scopes: 'Scopes',
    generating: 'Generating...',
    generateKey: 'Generate Key',
    keyGenerated: 'Key Generated',
    copySecretWarning: '⚠️ Copy your secret now — it will never be shown again.',
    apiKeyLabel: 'API Key',
    apiSecretLabel: 'API Secret',
    done: 'Done',
    enterKeyName: 'Enter a key name',
    failedToCreateKey: 'Failed to create key',
    keyRevoked: 'Key revoked',
    confirmRevoke: 'Revoke this API key? This cannot be undone.',
  },

  // Notifications
  notifications: {
    title: 'Notification Settings',
    emailNotifications: 'Email Notifications',
    smsNotifications: 'SMS Notifications',
    pushNotifications: 'Push Notifications',
    deposits: 'Deposits',
    withdrawals: 'Withdrawals',
    newClients: 'New Clients',
    kycApplications: 'KYC Applications',
    systemAlerts: 'System Alerts',
    enabled: 'Enabled',
    disabled: 'Disabled',
    saveSettings: 'Save Settings',
    settingsSaved: 'Settings saved successfully',


    notificationChannels: 'Notification Channels',
    configureChannels: 'Configure how your platform sends alerts to clients. Enable only the channels you\'ve set up.',
    saveAll: 'Save All',
    saving: 'Saving...',
    saveSettings: 'Save Settings',
    enableToConfigure: 'Enable to configure {title}',

    // Email
    emailSmtp: 'Email (SMTP)',
    emailSmtpSubtitle: 'Send emails via your own SMTP server',
    recommended: 'Recommended',
    smtpHost: 'SMTP Host',
    smtpPort: 'SMTP Port',
    usernameEmail: 'Username / Email',
    passwordAppPassword: 'Password / App Password',
    fromEmail: 'From Email',
    fromName: 'From Name',
    useTls: 'Use TLS / STARTTLS',
    useTlsHint: 'Recommended for port 587. Disable for port 465 (SSL).',
    sendTestEmail: 'Send Test Email',

    // Push
    pushFcm: 'Push Notifications (FCM)',
    pushFcmSubtitle: 'Firebase Cloud Messaging for Android, iOS & Web',
    pushSetupRequired: 'Setup required',
    pushSetupDesc: 'Go to Firebase Console → Project Settings → Service Accounts → Generate new private key. Download the JSON file and upload it below.',
    serviceAccountCredentials: 'Service Account Credentials',
    clientTokenStatus: 'Client Token Status',
    clientTokenDesc: 'Push tokens are registered automatically when clients log in on mobile/web. No manual config needed.',
    testPush: 'Test Push',
    webAppConfig: 'Web App Config',
    webAppConfigured: 'Configured — {project}',
    webAppRequired: 'Required for browser & mobile push',
    webAppWhereToFind: 'Where to find these',
    webAppWhereToFindDesc: 'Firebase Console → Project Settings → Your apps → Web app → SDK setup and configuration',
    saveWebConfig: 'Save Web Config',
    vapidKey: 'VAPID Key',
    vapidKeyHint: '— Cloud Messaging tab → Web Push certificates → Generate key pair',

    // FCM Upload
    credentialsOnFile: 'Credentials on file',
    credentialsStoredSecurely: 'Stored securely on the server',
    replaceCredentials: 'Replace',
    uploadServiceAccount: 'Upload service account JSON',
    uploadServiceAccountHint: 'Click to select — file is validated and stored securely on the server',
    uploadingValidating: 'Uploading & validating...',
    uploadSuccess: 'Firebase credentials uploaded successfully',
    uploadFailed: 'Upload failed — check file is a valid Firebase service account JSON',
    saveWebConfigSuccess: 'Firebase web config saved',
    saveWebConfigFailed: 'Failed to save web config',

    // SMS
    smsTwilio: 'SMS (Twilio)',
    smsTwilioSubtitle: 'Send SMS alerts via Twilio to clients with phone numbers',
    smsSetupRequired: 'Setup required',
    smsSetupDesc: 'Get your credentials from console.twilio.com → Account → API keys & tokens. You\'ll also need a Twilio phone number.',
    accountSid: 'Account SID',
    accountSidHint: 'Starts with AC...',
    authToken: 'Auth Token',
    fromPhoneNumber: 'From Phone Number',
    fromPhoneHint: 'E.164 format, e.g. +12025551234',
    sendTestSms: 'Send Test SMS',

    // Status badges
    statusConnected: 'Connected',
    statusError: 'Error',
    statusUntested: 'Not Tested',
    statusTesting: 'Testing...',

    // Notification routing
    notificationRouting: 'Notification Routing',
    notificationRoutingDesc: 'Choose which channels each notification type uses',
    noChannelsEnabled: 'No channels enabled',
    noChannelsEnabledDesc: 'Enable at least one channel above to configure notification routing',

    // Notification types
    notifMarginCall: 'Margin Call',
    notifMarginCallDesc: 'When account margin level drops below threshold',
    notifLiquidation: 'Liquidation',
    notifLiquidationDesc: 'When positions are force-closed',
    notifDeposit: 'Deposit',
    notifDepositDesc: 'When a deposit is confirmed',
    notifWithdrawal: 'Withdrawal',
    notifWithdrawalDesc: 'When a withdrawal is processed',
    notifTradeOpened: 'Trade Opened',
    notifTradeOpenedDesc: 'When a new position is opened',
    notifTradeClosed: 'Trade Closed',
    notifTradeClosedDesc: 'When a position is closed',

    // Load/save messages
    failedToLoad: 'Failed to load notification settings',
    failedToSave: 'Failed to save',
    testSuccess: '{channel} test successful — check your inbox/device',
    testFailed: '{channel} test failed',
  },

  // Upgrade
  upgrade: {
    title: 'Upgrade Plan',
    currentPlan: 'Current Plan',
    choosePlan: 'Choose Plan',
    basic: 'Basic',
    professional: 'Professional',
    enterprise: 'Enterprise',
    perMonth: '/month',
    perYear: '/year',
    monthly: 'Monthly',
    annually: 'Annually',
    features: 'Features',
    selectPlan: 'Select Plan',
    currentPlanLabel: 'Current Plan',
    upgradeTo: 'Upgrade to',
    contactSales: 'Contact Sales',
    unlimitedClients: 'Unlimited Clients',
    unlimitedAccounts: 'Unlimited Accounts',
    advancedReporting: 'Advanced Reporting',
    prioritySupport: 'Priority Support',
    apiAccess: 'API Access',
    customBranding: 'Custom Branding',
    whiteLabel: 'White Label',
    dedicatedManager: 'Dedicated Account Manager',
    upgradeAvailable: 'Upgrade Available',
    plan: 'Plan',
    unlock: 'Unlock',
    apiAccessFeature: ', API access',
    andMore: '& more',
    renew: 'Renew',
  },

  // Theme
  theme: {
    light: 'Light Mode',
    dark: 'Dark Mode',
    toggle: 'Toggle Theme',
  },

  // Language
  language: {
    english: 'English',
    arabic: 'العربية',
    turkish: 'Türkçe',
    select: 'Select Language',
  },

  // Errors
  errors: {
    general: 'Something went wrong',
    networkError: 'Network error. Please check your connection.',
    unauthorized: 'Unauthorized. Please login again.',
    forbidden: 'Access denied.',
    notFound: 'Resource not found.',
    serverError: 'Server error. Please try again later.',
    actionFailed: 'Action failed',
  },

  // Success messages
  success: {
    saved: 'Saved successfully',
    updated: 'Updated successfully',
    deleted: 'Deleted successfully',
    created: 'Created successfully',
    copied: 'Copied to clipboard',
  },

  // Time & Date
  time: {
    seconds: 'seconds',
    minutes: 'minutes',
    hours: 'hours',
    days: 'days',
    weeks: 'weeks',
    months: 'months',
    years: 'years',
    ago: 'ago',
    justNow: 'just now',
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
  },

  // Units
  units: {
    usd: 'USD',
    eur: 'EUR',
    gbp: 'GBP',
    lot: 'lot',
    lots: 'lots',
    pips: 'pips',
    percent: '%',
  },

  cascade: {
    settingsArchitecture: 'Settings Architecture',
    title: 'Cascade Priority System',
    subtitle: 'Settings resolve highest → lowest priority. Leave a field',
    subtitleNull: 'empty (NULL)',
    subtitleFallthrough: 'to skip that layer and fall through to the next.',
    resolutionOrder: 'Resolution Order:',
    firstNonNull: 'First non-null value wins',
    highestPriority: 'Highest Priority — Click any layer to explore',
    ifEmptyFallsThrough: '↓ if empty, falls through',
    priority: 'Priority',
    leaveFieldEmpty: 'Leave any field empty (NULL)',
    skipLayer: 'to skip this layer and fall through to',
    finalFallback: 'Final fallback — no layer below.',
    hardLimitsNote: 'Fields marked',
    hardLimitsNote2: 'are hard limits enforced system-wide, no layer can bypass them.',

    // Layer labels
    layers: {
      userOverride: 'User Override',
      userSublabel: 'Per-client special deals',
      userTooltip: 'Highest priority. Any field set here wins over everything else. Use for VIP clients, restricted accounts, or special deals.',
      userFallsTo: 'Account Group (P2)',

      accountGroup: 'Account Group',
      groupSublabel: 'VIP, Standard, Professional tiers',
      groupTooltip: 'Applied to all clients in this group. If no user override exists, group settings apply. Great for tiered account types.',
      groupFallsTo: 'Symbol Settings (P3)',

      symbolSettings: 'Symbol Settings',
      symbolSublabel: 'Per-instrument broker config',
      symbolTooltip: 'Controls pricing and execution rules per instrument. E.g. XAUUSD gets different spread markup than EURUSD.',
      symbolFallsTo: 'Platform Defaults (P4)',

      platformDefaults: 'Platform Defaults',
      platformSublabel: 'System fallback & hard caps',
      platformTooltip: 'Lowest priority for defaults, but enforces absolute hard caps no other layer can override. Managed by system admin only.',
    },

    // Who labels
    setByBroker: 'Set by Broker',
    setBySystemAdmin: 'Set by System Admin',

    // Navigation labels
    goToClients: 'Go to Clients',
    goToAccountGroups: 'Go to Account Groups',
    goToInstruments: 'Go to Instruments',

    // Field names
    fields: {
      maxLeverage: 'Max Leverage',
      maxLotSize: 'Max Lot Size',
      marginCallLevel: 'Margin Call Level',
      stopOutLevel: 'Stop Out Level',
      maxOpenPositions: 'Max Open Positions',
      commissionPerLot: 'Commission Per Lot',
      tradingDisabled: 'Trading Disabled',
      spreadMarkup: 'Spread Markup',
      swapMarkup: 'Swap Markup',
      tripleSwapDay: 'Triple Swap Day',
      stopLevel: 'Stop Level',
      freezeLevel: 'Freeze Level',
      defaultLeverage: 'Default Leverage',
      defaultCommission: 'Default Commission',
      defaultMarginCall: 'Default Margin Call',
      defaultStopOut: 'Default Stop Out',
      maxLeverageCap: 'Max Leverage Cap',
      minMarginCall: 'Min Margin Call',
      minStopOut: 'Min Stop Out',
      maxCommissionCap: 'Max Commission Cap',
      maxPositionsCap: 'Max Positions Cap',
    },

    // Field descriptions
    fieldDescs: {
      capLeverageClient: 'Cap leverage for this specific client',
      limitPositionSize: 'Limit position size per trade',
      overrideAlertThreshold: 'Override alert threshold',
      overrideAutoClose: 'Override auto-close threshold',
      limitConcurrentTrades: 'Limit concurrent trades',
      customCommission: 'Custom commission rate (e.g. VIP = 0)',
      killSwitch: 'Emergency kill switch for this client',
      groupCommission: 'Group-wide commission rate',
      groupLeverage: 'Group leverage cap',
      groupMarginCall: 'Group alert threshold',
      groupStopOut: 'Group auto-close threshold',
      groupPositions: 'Group position limit',
      groupLotSize: 'Group trade size limit',
      pipsAddedSpread: 'Pips added to raw spread',
      symbolCommission: 'Symbol-specific commission',
      overnightSwap: 'Added to overnight swap rates',
      tripleSwapDay: 'Day when 3x swap is charged',
      symbolLeverage: 'Symbol leverage cap',
      symbolLotSize: 'Symbol trade size limit',
      minSlTpDistance: 'Min SL/TP distance in pips',
      modificationFreeze: 'Modification freeze distance',
      fallbackLeverage: 'Fallback if no layer sets it',
      fallbackCommission: 'Fallback commission rate',
      fallbackMarginCall: 'Fallback alert level',
      fallbackStopOut: 'Fallback auto-close level',
      hardCeilingLeverage: 'Hard ceiling — no layer can exceed',
      hardFloorMarginCall: 'Hard floor — no layer can go below',
      hardFloorStopOut: 'Hard floor — no layer can go below',
      hardCeilingCommission: 'Hard ceiling on commission',
      systemPositionLimit: 'System-wide position limit',
    },
  },

  emailTemplates: {
    loadingTemplates: 'Loading email templates…',
    loadingTemplate: 'Loading template…',
    retry: 'Retry',
    allTemplates: '← All Templates',
    customised: 'Customised',
    custom: 'Custom',
    default: 'Default',
    subjectLine: 'Subject Line',
    subjectPlaceholder: 'Email subject…',
    editorTab: 'Editor',
    htmlTab: 'HTML',
    previewTab: 'Preview',
    variables: 'Variables:',
    showLess: 'Show less',
    clickToInsert: 'Click to insert variable:',
    saveTemplate: 'Save Template',
    savingTemplate: 'Saving…',
    resetToDefault: 'Reset to Default',
    resetting: 'Resetting…',
    back: 'Back',
    resetConfirm: 'Reset to the default premium template? Your customizations will be lost.',
    subjectBodyRequired: 'Subject and body are required',
    activeBranding: 'Active Branding',
    companyName: 'Company Name',
    primaryColor: 'Primary Color',
    logoUrl: 'Logo URL',
    noLogoSet: 'No logo set',
    emailFooter: 'Email Footer',
    brandingNote: 'To update your branding, go to Broker Settings. Changes apply to all email templates automatically.',
    editBranding: 'Edit Branding',
    closeBranding: 'Close Branding',
    templateListDesc: 'Click a template to edit. Customised templates override the premium defaults.',
    templateInfoNote: 'Templates marked Default use the built-in premium design with your branding applied. Click any template to customise it. Use Reset to Default inside the editor to revert your changes.',
    loadingBranding: 'Loading branding…',

    typeDepositApproved: 'Deposit Approved',
    typeDepositRejected: 'Deposit Rejected',
    typeWithdrawalApproved: 'Withdrawal Approved',
    typeWithdrawalRejected: 'Withdrawal Rejected',
    typeMarginCall: 'Margin Call',
    typeLiquidation: 'Account Liquidated',
    typeKycApproved: 'KYC Approved',
    typeKycRejected: 'KYC Rejected',
    typeWelcome: 'Welcome Email',
  },


  credits: {
    activeRules: 'Active Rules',
    totalAwarded: 'Total Awarded',
    awardEvents: 'Award Events',
    bonusRules: 'Bonus Rules',
    awardHistory: 'Award History',
    newRule: 'New rule',
    manualAward: 'Manual award',
    noBonusRules: 'No bonus rules yet. Add one to start auto-awarding credit on deposits.',
    noCreditAwards: 'No credit awards yet.',
    deactivateConfirm: 'Deactivate this rule?',
    revokeReason: 'Revoke reason (optional):',
    operationFailed: 'Operation failed',
    bonusRuleTitle: '{mode} Bonus Rule',
    ruleName: 'Rule name (e.g. Welcome Bonus)',
    percentOfDeposit: '% of deposit (e.g. 20)',
    fixedAmountUsd: 'Fixed amount (USD)',
    maxCreditCap: 'Max credit cap (optional)',
    minDepositQualify: 'Min deposit to qualify',
    expiresAfterDays: 'Expires after N days (optional)',
    ruleActive: 'Active — auto-awards on qualifying deposits',
    ruleDisabled: 'Disabled',
    savingDots: 'Saving…',
    awardingDots: 'Awarding…',
    manualCreditAward: 'Manual Credit Award',
    accountId: 'Account ID',
    userId: 'User ID',
    amountUsd: 'Amount (USD)',
    notesOptional: 'Notes (optional)',
    awardCredit: 'Award Credit',
    infoWelcomeDeposit: 'WELCOME and DEPOSIT rules fire automatically on deposit approval. GOODWILL and PROMOTION are awarded manually. Credit is wiped on liquidation.',
    bonusWelcome: 'Welcome',
    bonusDeposit: 'Deposit',
    bonusGoodwill: 'Goodwill',
    bonusPromotion: 'Promotion',
    statusRevoked: 'Revoked',
    statusExpired: 'Expired',
  },
  pages: {
    // UI strings
    websitePages: 'Website Pages',
    websitePagesDesc: 'Build and manage your website.',
    pluginNotActive: 'Plugin not active.',
    viewPlugins: 'View Plugins',
    mainPages: 'Main Pages',
    legalPages: 'Legal Pages',
    langs: 'langs',

    // Page editor
    save: 'Save',
    saved: 'Saved',
    error: 'Error',
    publish: 'Publish',
    unpublish: 'Unpublish',
    published: 'Published',
    draft: 'Draft',
    tabBlocks: 'Blocks',
    tabSeo: 'SEO',
    addBlock: 'Add Block',
    addFirstBlock: 'Add First Block',
    addFirstBlockHint: 'Add your first content block',
    noBlocks: 'No blocks yet',

    // SEO tab
    pageTitle: 'Page Title',
    pageTitleHint: 'This is the main page title shown in navigation and page header',
    translatable: 'Translatable',
    pageSlug: 'Page Slug',
    seoTitle: 'SEO Title',
    seoDescription: 'SEO Description',
    googlePreview: 'GOOGLE PREVIEW',
    noDescription: 'No description.',

    // Block picker categories
    catHeroLayout: 'Hero & Layout',
    catContent: 'Content',
    catFeaturesData: 'Features & Data',
    catSocialProof: 'Social Proof',
    catCta: 'Call to Action',
    catDocuments: 'Documents & Legal',
    catOther: 'Other',

    // Field helpers
    missing: 'Missing',
    add: 'Add',
    addItem: 'Add Item',
    item: 'Item',
    notStarted: 'Not started',
  },

  userOverride: {
    title: 'User Account Override',
    infoBannerTitle: 'User-Level Overrides (Layer 1)',
    infoBannerDesc: "These settings override the user's account group defaults. Leave fields empty (NULL) to use group settings.",
    sectionTradingControl: 'Trading Control',
    sectionRiskParameters: 'Risk Parameters',
    sectionPricingOverrides: 'Pricing Overrides',
    disableTrading: 'Disable Trading',
    disableTradingSubLabel: 'Prevent this user from opening new positions',
    resetToGroupDefault: 'Reset to Group Default',
    groupDefault: 'Group Default',
    maxLeverage: 'Max Leverage',
    maxLotSize: 'Max Lot Size',
    minLotSize: 'Min Lot Size',
    marginCallLevel: 'Margin Call Level (%)',
    stopOutLevel: 'Stop Out Level (%)',
    maxOpenPositions: 'Max Open Positions',
    commissionPerLot: 'Commission Per Lot (USD)',
    commissionPerLotHint: 'USD charged per standard lot traded',
    minAboveMaxError: '⚠️ Min Lot Size cannot exceed Max Lot Size',
    currentOverrideTitle: 'Current Override Active',
    currentOverrideDesc: 'This user has custom settings that override their account group defaults.',
    saveOverride: 'Save Override',
    saving: 'Saving...',
    saveSuccess: 'User override saved successfully',
    saveFailed: 'Failed to save user override',
    lots: 'lots',
    lotStep: 'Lot Step',
  },
  symbolSettings: {
    sectionPricing: 'Broker Pricing',
    sectionRisk: 'Risk Limits',
    sectionExecution: 'Execution Rules',
    sectionOverrides: 'Instrument Overrides',
    sectionsLabel: 'Sections',
    pricingDesc: 'Adjustments applied on top of the raw instrument rates for this broker.',
    riskDesc: 'Position and leverage limits applied at this broker level.',
    executionDesc: 'Order placement and modification constraints.',
    overridesDesc: 'Toggle each field to activate a broker-level override. Disabled fields fall back to the shared instrument table.',
    overridesInfoTitle: 'Swap Long / Swap Short',
    overridesInfoDesc: 'replace the instrument rate entirely when enabled — swap markup is not added on top. All other overrides cascade normally.',
    settingsTitle: '{symbol} Settings',
    headerSubtitle: 'Configure broker-level pricing and risk (Layer 3)',
    overrideActive: '{count} override active',
    overridesActive: '{count} overrides active',
    spreadMarkup: 'Spread Markup',
    spreadMarkupHint: 'Pips added to raw spread from liquidity provider',
    commissionPerLot: 'Commission Per Lot',
    commissionPerLotHint: 'USD charged per standard lot traded',
    swapMarkup: 'Swap Markup',
    swapMarkupHint: 'Points added on top of instrument swap rates. Ignored when swap_long / swap_short overrides are enabled.',
    tripleSwapDay: 'Triple Swap Day',
    tripleSwapDayHint: 'Day when triple swap is charged',
    maxLeverage: 'Max Leverage',
    maxLeverageHint: 'Maximum leverage allowed for this symbol',
    maxLotSize: 'Max Lot Size',
    maxLotSizeHint: 'Maximum position size per trade',
    minLotSize: 'Min Lot Size',
    minLotSizeHint: 'Minimum position size per trade',
    minAboveMaxError: '⚠️ Min Lot Size cannot exceed Max Lot Size',
    stopLevel: 'Stop Level',
    stopLevelHint: 'Minimum distance for SL/TP from current market price (pips)',
    freezeLevel: 'Freeze Level',
    freezeLevelHint: 'Distance at which order modifications are frozen (pips)',
    contractSize: 'Contract Size',
    contractSizeHint: 'Units per lot. e.g. 100000 for standard forex, 1 for stocks.',
    priceScale: 'Price Scale',
    priceScaleHint: 'Decimal places for price quoting. 5 = 1.23456, 2 = 1.23.',
    swapLong: 'Swap Long (direct rate)',
    swapLongHint: 'Overnight rate for BUY positions. Replaces instrument rate entirely.',
    swapShort: 'Swap Short (direct rate)',
    swapShortHint: 'Overnight rate for SELL positions. Replaces instrument rate entirely.',
    swapMode: 'Swap Mode',
    swapModeHint: 'How the overnight swap rate is calculated',
    maxVolume: 'Max Volume (lots)',
    maxVolumeHint: 'Maximum single trade size in lots for this broker.',
    volumeStep: 'Volume Step (lots)',
    volumeStepHint: 'Minimum trade size increment. e.g. 0.01 allows 0.01, 0.02, 0.03…',
    defaultBadge: 'default',
    pips: 'pips',
    pts: 'pts',
    lots: 'lots',
    decimals: 'decimals',
    dayMon: 'Mon',
    dayTue: 'Tue',
    dayWed: 'Wed',
    dayThu: 'Thu',
    dayFri: 'Fri',
    daySat: 'Sat',
    daySun: 'Sun',
    loadingSettings: 'Loading settings…',
    saveSettings: 'Save Settings',
    lotStep: 'Lot Step',
  },
  accountGroupForm: {
    sectionsLabel: 'Sections',
    sectionBasic: 'Basic Info',
    sectionPricing: 'Pricing Overrides',
    sectionRisk: 'Risk Management',
    editTitle: 'Edit Account Group',
    createTitle: 'Create Account Group',
    basicInfoTitle: 'Basic Information',
    groupNameLabel: 'Group Name *',
    groupNamePlaceholder: 'Standard Group',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Group description...',
    groupActive: 'Group Active',
    defaultGroup: 'Default Group',
    pricingTitle: 'Pricing Overrides',
    pricingDesc: 'Leave blank to use broker-level defaults. Only override if this group needs different pricing.',
    commissionPerLot: 'Commission Per Lot (USD)',
    commissionPerLotHint: 'USD charged per standard lot traded',
    maxLeverage: 'Max Leverage',
    maxLeverageHint: 'Maximum leverage available to this group',
    brokerDefault: 'Broker Default',
    resetToNoLimit: 'Reset to no limit',
    riskTitle: 'Risk Management',
    marginCallLevel: 'Margin Call Level',
    marginCallHint: 'Alert when margin level reaches this percentage',
    stopOutLevel: 'Stop Out Level',
    stopOutHint: 'Auto-close positions at this margin level',
    maxOpenPositions: 'Max Open Positions',
    maxOpenPositionsHint: 'Maximum number of positions per account',
    maxLotSize: 'Max Lot Size',
    maxLotSizeHint: 'Maximum lot size per trade',
    minLotSize: 'Min Lot Size',
    minLotSizeHint: 'Minimum lot size per trade for this group',
    noLimit: 'No Limit',
    lots: 'lots',
    marginBelowStopError: '⚠️ Margin Call Level must be greater than Stop Out Level',
    minAboveMaxError: '⚠️ Min Lot Size cannot exceed Max Lot Size',
    updateGroup: 'Update Group',
    createGroup: 'Create Group',
    lotStep: 'Lot Step',
  },
  cryptoCheckout: {
    paymentConfirmedTitle: 'Payment Confirmed!',
    makePayment: 'Make Payment',
    depositFunds: 'Deposit Funds',
    purchaseItem: 'Purchase {name}',
    subscribeTo: 'Subscribe to {name}',
    selectPaymentMethod: 'Select payment method',
    payWith: 'Pay with {currencies}',
    creatingPayment: 'Creating payment...',
    continue: 'Continue',
    sendExactly: 'Send exactly',
    approxUsd: '≈ ${amount} USD',
    hideQrCode: 'Hide QR Code',
    showQrCode: 'Show QR Code',
    scanWithWallet: 'Scan with your mobile wallet',
    toThisAddress: 'To this {network} address',
    expiresIn: 'Expires in',
    waitingForPayment: 'Waiting for payment...',
    waitingDesc: "Send the exact amount. We'll detect it automatically.",
    verifiedOnChain: 'Verified on-chain by AmorPay. No intermediaries.',
    pluginActivated: '{name} has been activated.',
    depositCredited: 'Your deposit has been credited to your account.',
    subscriptionActive: 'Your subscription is now active.',
    paymentConfirmed: 'Your payment has been confirmed.',
    done: 'Done',
    noItemSelected: 'No item selected for purchase',
    failedToLoadOptions: 'Failed to load payment options',
  },
  subscriptionGate: {
    accountSuspended: 'Account Suspended',
    subscriptionExpired: 'Subscription Expired',
    suspendedDesc: 'Your account has been suspended. Please contact support to restore access.',
    expiredDesc: 'Your {plan} subscription has expired and the grace period has ended. Renew to restore full access.',
    renewSubscription: 'Renew Subscription',
    signOut: 'Sign out',
    needHelp: 'Need help? Contact',
    lastChance: '⚠️ Last chance! Your {plan} subscription expired. Access ends today.',
    gracePeriodDay: 'Your {plan} subscription has expired. You have {days} day left in your grace period.',
    gracePeriodDays: 'Your {plan} subscription has expired. You have {days} days left in your grace period.',
    renewNow: 'Renew Now',
  },
  upgradePage: {
    renewTitle: 'Renew Subscription',
    upgradeTitle: 'Upgrade Your Plan',
    currentlyOn: 'Currently on',
    graceDaysLeft: '{days} day left in grace period',
    graceDaysLeftPlural: '{days} days left in grace period',
    expired: 'Expired',
    graceWarning: 'Your subscription expired. You have {days} day left to renew before your account is locked.',
    graceWarningPlural: 'Your subscription expired. You have {days} days left to renew before your account is locked.',
    expiredWarning: 'Your subscription has fully expired. Renew now to restore access.',
    renewOrUpgrade: 'You can renew your current plan or upgrade to a higher tier.',
    monthly: 'Monthly',
    yearly: 'Yearly',
    mostPopular: 'Most Popular',
    currentPlan: 'Current Plan',
    perMonth: '/mo',
    saveYearly: 'Save 10% — billed ${amount}/yr',
    unlimitedTraders: 'Unlimited traders',
    tradersCount: '{count} traders',
    unlimitedAdmins: 'Unlimited admins',
    adminsCount: '{count} admins',
    unlimitedInstruments: 'Unlimited instruments',
    instrumentsCount: '{count} instruments',
    feedUltra: 'Ultra-low latency feed',
    feedPriority: 'Priority feed',
    feedStandard: 'Standard feed',
    fullApiAccess: 'Full API access',
    selected: 'Selected',
    selectPlan: 'Select Plan',
    fullComparison: 'Full comparison',
    featureCol: 'Feature',
    featureTraders: 'Traders',
    featureAdmins: 'Admins',
    featureInstruments: 'Instruments',
    featureFeedLatency: 'Feed Latency',
    featureApiAccess: 'API Access',
    featureForex: 'Forex',
    featureCrypto: 'Crypto',
    featureCommodities: 'Commodities',
    featureIndices: 'Indices',
    featureStocks: 'Stocks',
    selectedPlan: 'Selected:',
    selectToContinue: 'Select a plan to continue',
    perYear: '/yr',
    renewNow: 'Renew Now',
    upgradeNow: 'Upgrade Now',
    failedToLoadPlans: 'Failed to load plans',
    selectPlanFirst: 'Please select a plan first',
    planActivated: '{name} plan activated! 🎉',
  },
  sidebar: {
    sectionOverview: 'Overview',
    sectionManagement: 'Management',
    sectionTrading: 'Trading',
    sectionFinance: 'Finance',
    sectionPlugins: 'Plugins',
    sectionSystem: 'System',
    accountGroups: 'Account Groups',
    cascadeGuide: 'Cascade Guide',
    pluginStore: 'Plugin Store',
    kycVerification: 'KYC Verification',
    kycDashboard: 'KYC Dashboard',
    kycConfig: 'KYC Config',
    pages: 'Pages',
    credits: 'Credits',
    emailTemplates: 'Email Templates',
    restApi: 'REST API',
    advancedAnalytics: 'Advanced Analytics',
    descClients: 'Users · Settings · Overrides',
    descGroups: 'Groups · Settings · Overrides',
    descInstruments: 'Broker · Settings · Overrides',
    descAccounts: 'Accounts & balances',
    descCascade: 'Priority system explained',
    descAnalytics: 'AI-powered insights',
    badgeLive: 'Live',
    badgeActive: 'Active',
    badgeAddon: 'Add-on',
    badgePro: 'PRO',
    badgeApi: 'API',
    badgeConfig: 'Config',
    badgeHowItWorks: 'How it works',
    cascadeTipFallthrough: 'Leave fields empty to fall through to next layer',
  },
};